import state from './equipmentReviewState'
import mutations from './equipmentReviewMutations'
import actions from './equipmentReviewActions'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
}
